import Icon from '@expo/vector-icons/MaterialCommunityIcons';
import { Text, View } from 'react-native';
import { Colors } from '../themes';
import { getEnumKey } from '../utils/getEnumKey';
import { themedStyleSheet } from '../themes/themedStyleSheet';
import { tokens } from './crop-circle/tokens';

export enum StatusBadgeType {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type StatusBadgeProps = {
  type: StatusBadgeType;
  text?: string;
};

export const StatusBadge = (props: StatusBadgeProps) => {
  const styleName = getEnumKey(StatusBadgeType, props.type)?.toLowerCase();
  const badgeStyle = styles[styleName as keyof typeof styles];
  const textStyle = styles[`text_${styleName}` as keyof typeof styles];

  return (
    <View style={styles.container}>
      <View style={[styles.badge, badgeStyle]}>
        <Icon name="circle-small" size={32} style={[textStyle]} />
        <Text style={[styles.text, textStyle]}>{props.text}</Text>
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    maxWidth: 100,
    maxHeight: 30,
  },
  badge: {
    borderRadius: 16,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 0,
    paddingTop: 2,
    paddingRight: 8,
    paddingBottom: 2,
  },
  active: {
    backgroundColor: Colors.active,
  },
  // A solid semantic tint, not `role.destructiveTint`. That token is the error
  // red at 35% alpha, so it composited against whatever sat behind it: pale
  // pink on a light surface, dark maroon on a dark one, and the fixed dark
  // maroon label below then became unreadable. `active` above is already a
  // solid light semantic fill paired with a fixed dark label; this matches it,
  // so both badges read identically in either mode.
  inactive: {
    backgroundColor: tokens.colors.semantic.errorLight,
  },
  text: {
    fontSize: 12,
    lineHeight: 18,
    fontWeight: '500',
    textAlign: 'center',
    padding: 0,
    margin: 0,
    color: role.textStrong,
  },
  text_active: {
    color: '#037847',
  },
  text_inactive: {
    color: '#780303',
  },
}));
